<card-layout title="Your Injuries - Injury Details" icon="personal_injury">
    <div [ngModelGroup]="_formNames.YourInjuriesDetails" #formGroup="ngModelGroup" class="overlay-container">
        <div class="accordion">
            <mat-accordion>
                @for(i of _injury.injuryDetails; track i.injuryDetailId; let index = $index) {
                    <mat-expansion-panel [expanded]="i.accordionOpen">
                        <mat-expansion-panel-header>
                            Injury {{ index + 1 }} &nbsp;&nbsp; {{ getInjuryDetailDescription(i) }}
                        </mat-expansion-panel-header>
                        
                        <minster-select label="Area of body" [name]="'area-of-body' + index" [(ngModel)]="i.areaOfBodyId" [lookUp]="_bodyAreas" (ngModelChange)="onAreaOfBodyChange(index)" [required]="true" #areaOfBody="ngModel" [class.ng-invalid]="areaOfBody.invalid && areaOfBody.touched" [class.ng-touched]="areaOfBody.touched" [disabled]="_readonly"/>
                        @if(areaOfBody.invalid && areaOfBody.touched) {
                            <div class="error-message">
                                Area of body is required.
                            </div>
                        }
                        
                        <minster-select label="Body Part" [name]="'body-part-' + index" [(ngModel)]="i.bodyPartId" [lookUp]="i.filteredBodyParts" (ngModelChange)="onBodyPartChange(index)" [required]="true" #bodyPart="ngModel" [class.ng-invalid]="bodyPart.invalid && bodyPart.touched" [class.ng-touched]="bodyPart.touched" [disabled]="_readonly"/>
                        @if(bodyPart.invalid && bodyPart.touched) {
                            <div class="error-message">
                                Body part is required.
                            </div>
                        }

                        <minster-select label="Injury Type" [name]="'injury-type-' + index" [(ngModel)]="i.injuryTypeId" [lookUp]="i.filteredInjuryTypes" (ngModelChange)="onInjuryTypeChange(index)" [required]="true" #injuryType="ngModel" [class.ng-invalid]="injuryType.invalid && injuryType.touched" [class.ng-touched]="injuryType.touched" [disabled]="_readonly"/>
                        @if(injuryType.invalid && injuryType.touched) {
                            <div class="error-message">
                                Injury type is required.
                            </div>
                        }

                        <minster-show-hide [isVisible]="requiresOther(index)">
                            <minster-input label="Other" [name]="'pre-existing-injury-other-' + index" [(ngModel)]="i.injuryTypeOther" [inputType]="_inputTypes.AlphaNumeric" [maxLength]="500" [minLength]="2" [required]="requiresOther(index)" [disabled]="_readonly"/>
                            @if(otherRequired(index)) {
                                <div class="error-message">
                                    Other is required.
                                </div>
                            }
                        </minster-show-hide>

                        <minster-input label="Pre-Existing Injury" [name]="'pre-existing-injury-' + index" [(ngModel)]="i.preExistingInjury" [inputType]="_inputTypes.AlphaNumeric" [maxLength]="500" [minLength]="2" [disabled]="_readonly"/>
                        @if(_readonly == false) { 
                        <div class="button-right">
                            <button type="button" color="accent" mat-fab extended aria-label="Remove a Passenger" [disabled]="_readonly" (click)="onRemoveInjury(i)">
                                <mat-icon>remove-circle_outline</mat-icon>Remove
                            </button>
                        </div>
                        }                      
                    </mat-expansion-panel>
                }
            </mat-accordion>
        </div>

        <div class="button-right">
            <button type="button" class="add" color="accent" mat-fab extended="" aria-label="Add a Passenger"
                [disabled]="_readonly" (click)="onAddInjury()">
                <mat-icon>add</mat-icon> Add Injury
            </button>
        </div>

        <minster-checkbox label="Pre Existing Conditions?" [name]="_fcn.InjuryDetails.PreExistingConditions" [(ngModel)]="_injury.isInjuriesPreExisting" [required]="true" (ngModelChange)="updateValidators()" [showInfo]="true" [disabled]="_readonly"/>
        <minster-show-hide [isVisible]="_injury.isInjuriesPreExisting">
            <minster-text-area label="Pre Existing Conditions" [name]="_fcn.InjuryDetails.PreExistingConditionsDescription" [(ngModel)]="_injury.preExistingInjuriesDetail" [maxLength]="1000" [minLength]="2" [required]="_injury.isInjuriesPreExisting" errorText="Please enter a pre-existing condition description" [showInfo]="true" [disabled]="_readonly"/>
        </minster-show-hide>

        <minster-checkbox label="Is your whiplash exceptionally severe?" [name]="_fcn.InjuryDetails.WhiplashSevere" [(ngModel)]="_injury.isWhiplashSevere" [required]="true" (ngModelChange)="updateValidators()" [showInfo]="true" [disabled]="_readonly"/>
        <minster-show-hide [isVisible]="_injury.isWhiplashSevere">
            <minster-input label="If so why" [name]="_fcn.InjuryDetails.WhiplashSevereWhy" [(ngModel)]="_injury.severeWhiplashDescription" [required]="_injury.isWhiplashSevere" [disabled]="_readonly" />
        </minster-show-hide>

        <minster-checkbox label="Are your circumstances exceptional?" [name]="_fcn.InjuryDetails.CircumstancesExceptional" [(ngModel)]="_injury.isCircumstanceExceptional" [required]="true" (ngModelChange)="updateValidators()" [showInfo]="true" [disabled]="_readonly"/>
       
        <minster-show-hide [isVisible]="_injury.isCircumstanceExceptional">
            <minster-input label="If yes why" [name]="_fcn.InjuryDetails.CircumstancesExceptionalIfYesWhy" [(ngModel)]="_injury.circumstanceExceptionalDescription" [required]="_injury.isCircumstanceExceptional" [disabled]="_readonly" />
        </minster-show-hide>
    </div>
</card-layout>

<div class="back-next">
    <button mat-raised-button class="secondary-button" type="button" (click)="onPrevious()">Back</button>
    <button mat-raised-button color="accent" type="button" (click)="onNext()">Next</button>
</div>
